// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"152":"base","583":"licenses","667":"invoices","779":"error"}[chunkId] || chunkId) + "." + {"152":"560d176f","415":"7bbb803d","583":"ba153c30","667":"02875570","779":"a3061ec3"}[chunkId] + ".js";
};